const initials = "blogs/";
export const UPDATE_BLOGS = `${initials}UPDATE_BLOGS`;
export const FETCH_BLOGS_REQUEST = "blogs/FETCH_BLOGS_REQUEST";
export const FETCH_BLOGS_SUCCESS = "blogs/FETCH_BLOGS_SUCCESS";
export const FETCH_BLOGS_FAILURE = "blogs/FETCH_BLOGS_FAILURE";
